const automaticReports = require('./automaticReports')
const { devicesToProcess } = require('./util/device')
const { getTranslations } = require('./util/utils')
const traccarHelper = require('./util/traccar')

function calculateFuelDrop (position, positions) {
  const index = positions.indexOf(position)
  if (index > 0) {
    let backIndex = 1
    while ((backIndex < 10) && index - backIndex >= 0) {
      const positionBefore = positions[index - backIndex]
      const diff = positionBefore.attributes.fuel - position.attributes.fuel
      if (diff > 0) {
        return diff
      }
      backIndex++
    }
  }
  return 0
}

async function createFuelDropReport (from, to, userData, traccar) {
  console.log('Create FuelDropReport')

  const allData = {
    devices: [],
    from,
    to
  }

  const reportData = []
  reportData.push(allData)

  const devices = devicesToProcess(userData)

  const arrayOfArrays = automaticReports.sliceArray(devices, 50)
  let data = []

  const types = ['deviceFuelDrop']
  for (const a of arrayOfArrays) {
    const response = await traccar.reports.reportsEventsGet(from, to, a.map(d => d.id), null, types)
    data = data.concat(response.data)
  }
  console.log('FuelDrop Alerts:' + data.length)
  allData.totalDevices = 0
  allData.totalFuelDrops = 0
  allData.totalFuelDropLiters = 0

  for (const d of devices) {
    const alerts = data.filter(t => t.deviceId === d.id)
    if (alerts.length > 0) {
      const allInOne = await traccarHelper.getAllInOne(traccar, from, to, [d], true, false, false, false, 1, devices.length)
      const route = allInOne.route.filter(t => t.deviceId === d.id)

      for (const a of alerts) {
        a.fuelDropLiters = 0
        if (a.positionId > 0) {
          const position = route.find(p => p.id === a.positionId)
          if (position) {
            a.position = position
            const diff = calculateFuelDrop(position, route)
            a.fuelDropLiters = Math.round(diff * d.attributes.fuel_tank_capacity / 100)
          }
        }
      }

      // Filter wrong fuel drop values
      const filteredAlerts = alerts.filter(a => a.fuelDropLiters < d.attributes.fuel_tank_capacity && a.fuelDropLiters > 0)

      if (filteredAlerts.length > 0) {
        allData.devices.push({
          device: d,
          alerts: filteredAlerts
        })
      }
    }
  }

  return reportData
}

function exportFuelDropReportToExcel (userData, reportData) {
  console.log('Export to Excel')
  const translations = getTranslations(userData)

  const settings = {
    sheetName: 'FuelDropReport', // The name of the sheet
    fileName: 'FuelDropReport' // The name of the spreadsheet
  }
  const headers = [
    { label: translations.report.name, value: 'name' },
    { label: translations.report.driver, value: 'driver' },
    { label: translations.report.date, value: 'fixTime' },
    { label: translations.report.address, value: 'address' },
    { label: translations.report.fueldrop, value: 'fuelDropLiters' }
  ]
  let data = []
  if (reportData.devices) {
    reportData.devices.forEach(d => {
      data = data.concat(d.alerts.map(r => {
        return {
          driver: r.driverName,
          fuelDropLiters: r.fuelDropLiters,
          fixTime: new Date(r.position.fixTime).toLocaleString(),
          name: d.device.name,
          address: r.geofenceName || r.position.address
        }
      }))
    })
  }

  return {
    headers,
    data,
    settings
  }
}

function exportFuelDropReportToPDF (userData, reportData) {
  console.log('Export to PDF')
}

exports.createFuelDropReport = createFuelDropReport
exports.exportFuelDropReportToPDF = exportFuelDropReportToPDF
exports.exportFuelDropReportToExcel = exportFuelDropReportToExcel
exports.create = createFuelDropReport
exports.exportToPDF = exportFuelDropReportToPDF
exports.exportToExcel = exportFuelDropReportToExcel
